<div class="sign-in" *transloco="let t; read: 'global.mfa'">
  <logo class="sign-in__logo"></logo>

  <ui-language class="root__language" [horizontal]="true" [lightBackground]="true" [languages]="uiLanguages$ | async"
               [currentLanguage]="currentLanguage$ | async" (languageChanged)="languageChanged($event)">
  </ui-language>

  <!-- Loading state -->
  <div *ngIf="loading" class="mfa__loading">
    <div class="mfa__loading__spinner"></div>
    <p class="mfa__loading__text">{{ t('loading') }}</p>
  </div>

  <!-- Content when loaded -->
  <div class="sign-in__content" *ngIf="!loading">
    <ng-container *ngIf="step === 'code'">
        <div class="sign-in__form__info">{{ t('info') }}</div>
        <div class="sign-in__form__heading">{{ t('step1') }}</div>
        <div class="sign-in__form__hint" [innerHTML]="t('intro')"></div>

        <!-- QR Code Section -->
        <div class="mfa__qr">
        <!-- QR Code Loading State (only when no QR code exists) -->
        <div *ngIf="qrLoading && !setup?.qrCodePngBase64" class="mfa__qr__loading">
            <div class="mfa__qr__spinner"></div>
            <p class="mfa__qr__loading-text">{{ t('qrLoading') }}</p>
        </div>

        <!-- QR Code Error State -->
        <div *ngIf="qrError" class="mfa__qr__error">
            <div class="mfa__qr__error-icon"></div>
            <p class="mfa__qr__error-text">{{ t('qrError') }}</p>
            <button type="button" class="mfa__qr__retry" (click)="startMfaSetup()">
            {{ t('retry') }}
            </button>
        </div>

        <!-- QR Code Success State -->
        <div *ngIf="setup?.qrCodePngBase64" class="mfa__qr__success">
            <img
            [src]="'data:image/png;base64,' + setup.qrCodePngBase64"
            [alt]="t('qrCodeAlt')"
            (load)="onQrImageLoad()"
            (error)="onQrImageError()"
            class="mfa__qr__image"
            loading="eager"
            decoding="sync"
            draggable="false"
            style="image-rendering: pixelated;" />
        </div>
        </div>

        <!-- Manual Key Section -->
        <div class="mfa__manual" *ngIf="setup?.sharedKey as key">
        <div class="mfa__manual__label">{{ t('manualLabel') }}</div>
        <div class="mfa__manual__container">
            <div class="mfa__manual__key">{{ key }}</div>
            <button type="button" class="mfa__manual__copy" (click)="copyKey()">
            {{ t('copy') }}
            </button>
        </div>
        </div>
        <button class="sign-in__form__button" type="button" (click)="step = 'verify'">
            {{ t('next') }}
        </button>
    </ng-container>

    <form *ngIf="step === 'verify'" class="sign-in__form" [formGroup]="form" (ngSubmit)="verify()" novalidate>
      <div class="sign-in__form__heading">{{ t('step2') }}</div>
      <div class="sign-in__form__hint" [innerHTML]="t('verifyIntro')"></div>
      <ha-input
        type="text"
        class="sign-in__form__input"
        formControlName="verificationCode"
        [label]="t('codeLabel')"
        autocomplete="one-time-code"
        inputmode="numeric"
        [maxlength]="6"
        placeholder="000000">
      </ha-input>

      <!-- Error Display -->
      <div *ngIf="error" class="sign-in__form__error-message">
        {{ t(error) }}
      </div>

      <a *ngIf="step === 'verify'" class="sign-in__form__back sign-in__form__back__anchor" (click)="step = 'code'">{{ t('back') }}</a>
      <button class="sign-in__form__button" type="submit" [disabled]="saving || form.invalid">
        <span *ngIf="saving">{{ t('verifying') }}...</span>
        <span *ngIf="!saving">{{ t('verify') }}</span>
      </button>
    </form>

    <div *ngIf="step === 'code'" class="sign-in__back-to-login">
      <a routerLink="/login" class="sign-in__back-to-login__anchor">
        <ng-container *transloco="let tGlobal; read: 'global'">{{ tGlobal('backToLogin') }}</ng-container>
      </a>
    </div>
  </div>
</div>
